<ng-template #copyId>
  <button
    [cdkCopyToClipboard]="uuid()"
    (cdkCopyToClipboardCopied)="onCopyToClipboardSuccess()"
    class="flx-ds extra-small ternary"
    flxButton
    icon="center"
    type="button"
    aria-label="Copy session ID"
  >
    <flx-icon
      [name]="!copiedTextToClipboard() ? 'copy' : 'circle-check'"
      [class.text-green-300]="copiedTextToClipboard()"
    ></flx-icon>
  </button>
</ng-template>

@if (layout() === 'card') {
  <!-- Identity card of the session page: laid out like a Document Classifier's name and meta line. -->
  <div class="flex flex-col gap-2 min-w-0">
    <div class="flex items-center gap-3 min-w-0">
      <h1
        class="text-xl font-bold text-neutral-900 truncate"
        data-testid="ui-flow-session-name"
      >
        {{ name() }}
      </h1>
      <p-tag
        [value]="state()"
        [severity]="severity()"
        class="flx-tag flex"
      />
    </div>
    <div class="flex flex-wrap items-center gap-4 text-sm text-neutral-500">
      <span class="flex items-center gap-1">
        <i class="ph ph-layout text-base"></i>
        UI Flow
      </span>
      <span
        class="flex items-center gap-1"
        data-testid="ui-flow-session-id"
      >
        Session ID:
        <span class="font-semibold text-neutral-700">{{ uuid() }}</span>
        <ng-container *ngTemplateOutlet="copyId" />
      </span>
      @if (dateStarted()) {
        <span>Started: {{ dateStarted() | flxTableDateFormat }}</span>
      }
    </div>
  </div>
} @else {
  <div class="flex gap-4 items-center text-xs text-neutral-500 font-bold">
    <h1
      class="flex items-center gap-1"
      data-testid="ui-flow-session-name"
    >
      <i class="ph ph-layout text-base font-normal"></i>
      UI Flow:
      <span class="text-black">{{ name() }}</span>
    </h1>
    <h1
      class="relative flex flex-row items-center gap-2"
      data-testid="ui-flow-session-id"
    >
      UI Flow session ID:
      <div class="flex items-center">
        <div class="truncate w-14 text-black">
          {{ uuid() }}
        </div>
        <ng-container *ngTemplateOutlet="copyId" />
      </div>
    </h1>
    <p-tag
      [value]="state()"
      [severity]="severity()"
      class="flx-tag flex"
    />
  </div>
}
